// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3QW_w","info":"PatientInfo_info__1HwN_"};